import { Divider } from "@mui/material";

import { Text, OP } from "$components";
import { useProfileEDBContext } from "../context/ProfileEDBContext";
import { useStyles as useEDBProfileClasses } from "$containers/EDB/styles/EdbProfile.Styles";

export default function OPList() {
  const edbClasses = useEDBProfileClasses();

  const {
    edb,
    opList,
    isDisabled,

    // Functions
    onCancelOP,
    handleChangeOP,
    onDeleteOPItem,
    updateProductOPQty,
    onDeleteItemFromEdb,
  } = useProfileEDBContext();

  if (opList.length === 0) return null;

  return (
    <>
      <Divider className={edbClasses.divider} />
      <div className={edbClasses.informations}>
        <div className={edbClasses.informationsHeader}>
          <Text type="h3" className={edbClasses.informationsTitle}>
            Préparation
          </Text>
        </div>
        <div>
          {opList &&
            opList.map((op: any, index: number) => (
              <OP
                key={op.code}
                op={op}
                indexOP={index}
                isDisabled={isDisabled}
                handleChangeProductOP={updateProductOPQty}
                handleChangeOP={handleChangeOP}
                onCancelOP={onCancelOP}
                handleCancelOPItems={onDeleteOPItem}
                onDeleteItemFromEdb={onDeleteItemFromEdb}
                edb={edb}
                opList={opList}
              />
            ))}
        </div>
      </div>
    </>
  );
}
